import { webApiService } from '@/services'
import { Box, Button, CircularProgress, TextField } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import React, { useState } from 'react'
import { useTradeinContext } from '../hooks/useTradeinContext'
import NUIAlert from '@/components/Alert/Alert'

const DeviceMobile: React.FC<any> = () => {
  const { ctx, saveCtx } = useTradeinContext()
  const [loading, setLoading] = useState(false)

  const handleSerieChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, serie: event.target.value })
  }

  const handleSerieSave = (serie: string) => {
    setLoading(true)

    webApiService.update({ stage: 7, id: ctx.tradein.id, serie, id_seller: ctx.tradein.id_seller })
      .then(() => {
        enqueueSnackbar('Se actualizó el número de IMEI/serie.', { variant: 'success' })
      })
      .catch((error) => {
        enqueueSnackbar('Hubo un error al intentar guardar el número de IMEI/serie.', { variant: 'error' })
        console.log('error ==>', error)
      }).finally(() => {
        saveCtx({ ...ctx, reload: true })
        setLoading(false)
      })
  }

  return (
    <div className='bg-white rounded-lg shadow-lg p-4'>
      <h6 className='border-b-1 mb-2 font-bold text-xl pb-2'>Dispositivo</h6>
      <div className='grid grid-cols-12'>
        <div className='col-span-12'>
          <p className='mb-2'><strong>Tipo:</strong> {ctx.tradein.sbu}</p>
        </div>
        <div className='col-span-12'>
          <p className='mb-2'><strong>Marca:</strong> <span className={ctx.tradein.brand !== ctx.tradein.make && ctx.tradein.recalculate === '1' ? 'line-through' : ''}>{ctx.tradein.brand}</span> {ctx.tradein.brand !== ctx.tradein.make && ctx.tradein.recalculate === '1' ? <span className='fw-bold'>{ctx.tradein.make}</span> : null}</p>
        </div>
        <div className='col-span-12'>
          <p className='mb-2'><strong>Modelo:</strong> <span className={ctx.tradein.model !== ctx.tradein.modelName && ctx.tradein.recalculate === '1' ? 'line-through' : ''}>{ctx.tradein.model}</span> {ctx.tradein.model !== ctx.tradein.modelName && ctx.tradein.recalculate === '1' ? <span className='fw-bold'>{ctx.tradein.modelName}</span> : null}</p>
        </div>
        <div className='col-span-12'>
          <p className='mb-2'><strong>Capacidad:</strong> <span className={ctx.tradein.capacity !== ctx.tradein.memory && ctx.tradein.recalculate === '1' ? 'line-through' : ''}>{ctx.tradein.capacity}</span> {ctx.tradein.capacity !== ctx.tradein.memory && ctx.tradein.recalculate === '1' ? <span className='fw-bold'>{ctx.tradein.memory}</span> : null}</p>
        </div>
        {ctx.tradein.sbu === 'Notebook' && (
          <>
            <div className='col-span-12'>
              <p className='mb-2'><strong>CPU:</strong> {ctx.tradein.cpu}</p>
            </div>
            <div className='col-span-12'>
              <p className='mb-2'><strong>Generación del CPU:</strong> {ctx.tradein.cpuGeneration}</p>
            </div>
            <div className='col-span-12'>
              <p className='mb-2'><strong>Pantalla:</strong> {ctx.tradein.screenSize}</p>
            </div>
            <div className='col-span-12'>
              <p className='mb-2'><strong>Memoria RAM:</strong> {ctx.tradein.ram}</p>
            </div>
            <div className='col-span-12'>
              <p className='mb-2'><strong>Almacenamiento:</strong> {ctx.tradein.storage}</p>
            </div>
          </>
        )}
        <div className='col-span-12'>
          <div><strong>{ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple' ? 'N° de serie: ' : 'IMEI: '}</strong>
            {loading
              ? (
                <CircularProgress />
                )
              : ctx.tradein.id_status === 1
                ? (
                  <div className='bg-blue-200 p-4 border-blue-900'>
                    Se requiere el resultado de la auto evaluación para obtener {ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple' ? 'la serie' : 'el imei'}.
                  </div>
                  )
                : ctx.tradein.id_status === 6
                  ? <div className='bg-red-200 p-4 border-red-900'>Evaluación fallida</div>
                  : ctx.tradein.serie === null || ctx.tradein.serie === ''
                    ? (
                      <div>
                        <Box position='relative' display='flex' alignItems='center' mt={2} mb={2}>
                          <Box position='relative' flexGrow={1} mr={2}>
                            <TextField
                              className='search-box'
                              label={ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple' ? 'Agregar serie' : 'Agregar IMEI'}
                              variant='outlined'
                              size='small'
                              value={ctx.serie}
                              onChange={handleSerieChange}
                              style={{ width: '100%' }}
                            />
                          </Box>
                          <Button
                            variant='contained'
                            size='small'
                            color='primary'
                            onClick={() => handleSerieSave(ctx.serie)}
                          >
                            Guardar
                          </Button>
                        </Box>
                        <NUIAlert
                          type='info'
                        >
                          Asegúrate de que el número de serie/IMEI sea correcto, ya que no podrás modificarlo una vez guardado.
                        </NUIAlert>
                      </div>

                      )
                    : ctx.tradein.serie}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeviceMobile
